<template>
  <el-table-column
    :key="code"
    :label="name"
    :min-width="width"
    :fixed="false"
    align="center"
  >
    <template
      #default="scope"
    >
      <el-select
        v-if="edit"
        v-model="scope.row[code]"
        :disabled="disabled"
        size="small"
      >
        <el-option
          v-for="option in options"
          :key="option[keyField]"
          :label="option[valueField]"
          :value="option[keyField]"
        />
      </el-select>
      <ik-table-check-tag
        v-else
        :default-value="defaultValue"
        :value="scope.row[code]"
        :key-field="keyField"
        :value-field="valueField"
        :options="options"
      />
      <!-- 编辑模式  -->
      <!--      <ik-table-check-->
      <!--        v-if="edit"-->
      <!--        :ref="'input_' + scope.$index + '_' + code"-->
      <!--        v-model="scope.row[code]"-->
      <!--        :line="scope.$index"-->
      <!--        :code="code"-->
      <!--        :name="name"-->
      <!--        :default-value="defaultValue"-->
      <!--        :key-field="keyField"-->
      <!--        :value-field="valueField"-->
      <!--        :options="options"-->
      <!--        :require="getRequire"-->
      <!--        @onFieldChange="onFieldChange"-->
      <!--      />-->
      <!--      &lt;!&ndash; 显示模式 &ndash;&gt;-->
      <!--      <ik-table-check-tag-->
      <!--        v-else-->
      <!--        :default-value="defaultValue"-->
      <!--        :value="scope.row[code]"-->
      <!--        :key-field="keyField"-->
      <!--        :value-field="valueField"-->
      <!--        :options="options"-->
      <!--      />-->
    </template>
  </el-table-column>
</template>

<script>

import IkTableCheckTag from "@/components/ik/table/input/IkTableCheckTag/index.vue"

export default {
  name: 'IkColumnSelect',
  components: { IkTableCheckTag },
  model: {
    // 属性
    prop: 'value',
    // 事件
    event: 'input'
  },
  props: {
    code: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    width: {
      type: Number,
      default: 200
    },
    line: {
      type: Number,
      default: 0
    },
    value: {
      type: String,
      default: ''
    },
    edit: {
      type: Boolean,
      default: true
    },
    defaultValue: {
      type: String,
      default: ''
    },
    keyField: {
      type: String,
      default: 'key'
    },
    valueField: {
      type: String,
      default: 'value'
    },
    options: {
      type: Array,
      default: function() {
        return []
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    require: {
      type: Boolean,
      default: false
    },
    rules: {
      type: Array,
      default: function() {
        return []
      }
    }
  },
  data() {
    return {
      errorSign: [],
      message: []
    }
  },
  computed: {
    getRequire() {
      return this.require
    }
  },
  methods: {
    onFieldChange(line, code, oldValue, value, errorSign, message) {
      this.$set(this.errorSign, line, errorSign)
      this.$set(this.message, line, message)
      this.$emit('onFieldChange', line, code, oldValue, value, errorSign, message)
    }
  }
}
</script>
<style scoped>
::v-deep.require > .el-input__inner {
  border: red 1px solid;
}
</style>
<style lang="scss">
.el-form-item {
  margin-bottom: 12px;
  width: 100%;
}

.el-form-item__label {
  width: 180px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.el-form-item__content {
  width: calc(100% - 180px);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
